var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['comp-content', _vm.component.active ? 'active' : ''],style:(_vm.getStyle),attrs:{"comp-id":_vm.component.domId}},[_c('div',{staticClass:"text-box",domProps:{"innerHTML":_vm._s(_vm.getText)}})])}
var staticRenderFns = []

export { render, staticRenderFns }